import { useTranslation } from "react-i18next";

import WPTabs from "../../../packages/WPTabs";

import PlantSetupTab from "./PlantSetupTab";
import TrainConfigTab from "./TrainConfigTab";

import "./ConfigPreview.scss";

const ConfigPreview = ({
  config,
  chemicalData,
  setChemicalData,
  trainCaseRoMap,
  setTrainCaseRoMap,
  setNormalizedSettingsAndCosts,
}) => {
  const { t } = useTranslation();

  const tabs = [
    {
      id: "wavepro-plant-setup-tab",
      title: t("roAdvisorProject.plantSetup"),
    },
    {
      id: "wavepro-train-configuration-tab",
      title: t("importPlantWavePro.trainConfigurationTab"),
    },
  ];

  return (
    <div className="wavepro-config-preview">
      <WPTabs tabs={tabs} className="wavepro-preview-tabs">
        <PlantSetupTab
          config={config}
          chemicalData={chemicalData}
          setChemicalData={setChemicalData}
          setNormalizedSettingsAndCosts={setNormalizedSettingsAndCosts}
        />
        <TrainConfigTab
          config={config}
          trainCaseRoMap={trainCaseRoMap}
          setTrainCaseRoMap={setTrainCaseRoMap}
        />
      </WPTabs>
    </div>
  );
};

export default ConfigPreview;
